import classNames from 'classnames';
import { FunctionComponent, memo } from 'react';
import { ImageFile } from '../../models';
import { Avatar } from '../Avatar';

import classes from './UserDisplayItem.module.scss';

interface UserDisplayItemProps {
  screenName: string;
  avatar?: ImageFile | null;
  email?: string;
  showEmail?: boolean;
  hover?: boolean;
  className?: string;
  onClick?: () => void;
}

export const UserDisplayItem: FunctionComponent<UserDisplayItemProps> = memo(
  ({ screenName, avatar, className, email, showEmail, hover, onClick }) => (
    <div
      className={classNames(classes['user-display-item'], className, {
        [classes['user-display-item--clickable']]: Boolean(onClick),
        [classes['user-display-item--hover']]: hover,
      })}
      onClick={onClick}
    >
      <Avatar url={avatar?.url} />
      <div className={classes['user-display-item__name']}>{screenName}</div>
      {showEmail && email && (
        <div className={classes['user-display-item__email']}>{`(${email})`}</div>
      )}
    </div>
  )
);
